import { render, staticRenderFns } from "./ProductPolicies.vue?vue&type=template&id=e667a646&scoped=true&"
import script from "./ProductPolicies.vue?vue&type=script&lang=js&"
export * from "./ProductPolicies.vue?vue&type=script&lang=js&"
import style0 from "./ProductPolicies.vue?vue&type=style&index=0&id=e667a646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e667a646",
  null
  
)

export default component.exports